module.exports = __webpack_public_path__ + "img/antes_despues_264.12e25247.png";